import { combineReducers } from 'redux';

const pageSettings = (state = {},  action) => {

    switch(action.type){
        case "SET_PAGE":
            return {
                ...state,
                page  : action.page.name
            }
        case "GET_PAGE":
            return {
                ...state,
                page : state.page
            }
        default:
            return state;
    }
}


const userSettings = (state = {loggedin : false, loggedUserData : undefined ,loggedout : undefined},  action) => {

    switch(action.type){
        case "USER_LOGGEDIN":
            return {
                ...state,
                loggedin : true,
                loggedUserData : (action.loggedInUser && action.loggedInUser.data)? (action.loggedInUser.data.response) : state.loggedUserData,

            }
        case "USER_LOGGEDOUT":
            return {
                ...state,
                loggedin : false,
                loggedUserData : undefined
            }
        default:
            return state;
    }
}


const pages = combineReducers({
    pageSettings,
    userSettings
})

export default pages;
//export const getPageSettings = state => state.pages.pageSettings;


// WEBPACK FOOTER //
// ./src/reducers/pages.js